module.exports = __webpack_public_path__ + "static/media/moveis.9af1e3c0.svg";